import { createUserAssetRuleFilter } from '../../factories';
import { fetchUserAssetRulesList } from '../../services';

enum AssetType {
  epg = 0,
  media = 1,
  npvr = 2,
}

export async function fetchChannelAssetRule(assetId: number) {
  const { objects } = await fetchUserAssetRulesList({
    filter: createUserAssetRuleFilter({
      assetIdEqual: assetId,
      assetTypeEqual: AssetType.media,
    }),
  });

  return objects;
}
